
import { computed, defineComponent, PropType, onMounted, ref, onUnmounted } from "vue";
import VueScrollTo from "vue-scrollto";
import UserSnsButtons from "~/components/UserAccounts/UserSnsButtons.vue";
import CompanyName from "~/components/UserAccounts/CompanyName.vue";
import UserAccountModel from "~/models/UserAccountModel";

type Props = {
  userAccount: UserAccountModel
};

export default defineComponent({
  name: "CorporateHeader",
  components: {
    CompanyName,
    UserSnsButtons
  },
  props: {
    userAccount: {
      type: Object as PropType<UserAccountModel>,
      required: true
    },
    mediumId: {
      type: Number,
      default: 0
    }
  },
  setup(props: Props) {
    const pressKitUrl = computed(() => {
      return `/corporation/${props.userAccount.userAccountId}/press_kit/download`;
    });

    const locationHash = ref(location.hash);
    const linkClass = (idName) => {
      const isActive = locationHash.value.replace("#", "") === idName;
      return {
        active: isActive
      };
    };

    // 企業ページトップかどうか
    const isCorporateTopPage = computed(() => {
      const userAccountId = props.userAccount.userAccountId;
      const path = new RegExp(`/corporation/(${userAccountId}$|${userAccountId}/$|${userAccountId}#.+$)`);
      return location.href.match(path) !== null;
    });

    const syncLocationHash = () => {
      locationHash.value = location.hash;
    };
    onMounted(() => {
      addEventListener("hashchange", syncLocationHash);
    });
    onUnmounted(() => {
      removeEventListener("hashchange", syncLocationHash);
    });

    const move = (element) => {
      VueScrollTo.scrollTo(element);
      location.hash = element;
    };

    return {
      pressKitUrl,
      isCorporateTopPage,
      linkClass,
      move
    };
  }
});
